// src/lib/seasonalPromo.js

/**
 * Western (Gregorian) Easter Sunday calculation (Anonymous Gregorian algorithm).
 * Returns a Date at local midnight.
 */
export function getEasterSunday(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31); // 3=March, 4=April
  const day = ((h + l - 7 * m + 114) % 31) + 1;

  // JS Date month is 0-based
  return new Date(year, month - 1, day, 0, 0, 0, 0);
}

function startOfDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
}

function diffDays(a, b) {
  // a - b in whole days
  const msPerDay = 24 * 60 * 60 * 1000;
  return Math.floor((startOfDay(a) - startOfDay(b)) / msPerDay);
}

/**
 * Returns promo info if within N days BEFORE the target date (inclusive).
 * Example: withinDaysBefore(today, target, 42) => true if 0..42 days before.
 */
function withinDaysBefore(today, targetDate, days) {
  const d = diffDays(targetDate, today); // how many days until target
  return d >= 0 && d <= days;
}

/**
 * Determine whether we are within 6 weeks of Christmas or Easter (leading up to the day).
 * Returns:
 *  - { key: "christmas" | "easter", title, body } or null
 */
export function getSeasonalPromo(today = new Date(), windowDays = 42) {
  const year = today.getFullYear();

  // Christmas this year
  const christmas = new Date(year, 11, 25, 0, 0, 0, 0);

  // Easter this year
  const easter = getEasterSunday(year);

  // If Easter already passed, you might want to check next year's Easter (optional).
  // But your request was "within 6 weeks of Easter" (typically leading up to Easter of the current year).
  // If you want "next upcoming Easter" behavior year-round, tell me and I’ll adjust.

  if (withinDaysBefore(today, christmas, windowDays)) {
      return {
          key: "christmas",
          title: "Prepare for Christmas Mass",
          body:
          "20% off all services until Christmas Day",
        };
    }
    
    if (withinDaysBefore(today, easter, windowDays)) {
    return {
      key: "easter",
      title: "Prepare for Holy Week & Easter",
      body:
        "20% off all services until Easter Sunday",
    };
  }

  return null;
}